import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { MenuItem } from 'primeng/api';
import { StepperModule } from 'primeng/stepper';
import { BankAccount } from '../wallet.model';
import { Subscription } from 'rxjs';
import { WalletService } from '../wallet.service';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { BankAccountsListComponent } from '../bank-accounts-list/bank-accounts-list.component';
import { DividerModule } from 'primeng/divider';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CopyClipboardDirective } from '@shared/directives/copy-clipboard.directive';

@Component({
  selector: 'app-bank-account-deposit',
  imports: [
    BreadcrumbComponent,
    StepperModule,
    ButtonModule,
    CardModule,
    BankAccountsListComponent,
    DividerModule,
    AngularSvgIconModule,
    CopyClipboardDirective,
  ],
  templateUrl: './bank-account-deposit.component.html',
})
export class BankAccountDepositComponent implements OnInit, OnDestroy {
  bankAccounts: BankAccount[] = [];

  readonly breadcrumdItems: MenuItem[] = [
    {
      label: 'Wallet',
      routerLink: '/home/wallet',
    },
    {
      label: 'Bank Deposit',
    },
  ];

  private bankAccountsSub = Subscription.EMPTY;

  readonly _walletService = inject(WalletService);

  public ngOnInit(): void {
    this.bankAccountsSub = this._walletService.bankAccounts$.subscribe(
      (bankAccounts) => (this.bankAccounts = bankAccounts)
    );
  }

  public ngOnDestroy(): void {
    this.bankAccountsSub.unsubscribe();
  }
}
